import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-[var(--radius-pill)] px-2 py-0.5 text-xs font-medium',
  {
    variants: {
      tone: {
        neutral:
          'bg-[color:var(--color-surface-2)] text-[color:var(--color-fg)] border border-[color:var(--color-border)]',
        info: 'bg-[color:var(--color-info-soft)] text-[color:var(--color-info)] border border-[color:var(--color-info)]',
        success:
          'bg-[color:var(--color-success-soft)] text-[color:var(--color-success)] border border-[color:var(--color-success)]',
        warn: 'bg-[color:var(--color-warn-soft)] text-[color:var(--color-warn)] border border-[color:var(--color-warn)]',
        danger:
          'bg-[color:var(--color-danger-soft)] text-[color:var(--color-danger)] border border-[color:var(--color-danger)]',
        accent:
          'bg-[color:var(--color-accent-soft)] text-[color:var(--color-accent)] border border-[color:var(--color-accent)]',
      },
    },
    defaultVariants: { tone: 'neutral' },
  }
);

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof badgeVariants>;

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
